import '../namespace'

import { ServiceConfigItemTypes } from '../common/constants'
import type { ConfigItem } from '../common/types'
import { normalizeConfigItems } from './config'
import { type ServiceClassType } from './constants'
import type { ConfigItemSource } from './types'

// The shared global `Flowrunner` is installed by ../namespace (imported above for its side effect). This
// module owns only the v1 registration seam: `createFlowrunnerSandboxV1` toggles `Flowrunner.ServerCode` for
// the duration of a v1 require so the required module's `addService(...)` call lands in the `services` map.

interface RegisteredService {
  ServiceClass: ServiceClassType
  configItems: ConfigItem[]
}

const services = new Map<string, RegisteredService>()

export function createFlowrunnerSandboxV1(serviceId: string, cb: () => void): RegisteredService | undefined {
  global.Flowrunner.ServerCode = {
    addService(ServiceClass: ServiceClassType, sourceConfigItems?: ConfigItemSource[]) {
      services.set(serviceId, {
        ServiceClass,
        configItems: normalizeConfigItems(sourceConfigItems),
      })
    },

    ConfigItems: {
      TYPES: ServiceConfigItemTypes,
    },
  }

  try {
    cb()
  } finally {
    global.Flowrunner.ServerCode = null
  }

  return services.get(serviceId)
}

